import { useEffect } from 'react';

export const useMapResizerOnSidebarToggle = (toggle: boolean, mapResizeCallback: () => void) => {
    useEffect(() => {
        toggle && mapResizeCallback && mapResizeCallback();
    }, [toggle, mapResizeCallback]);
};
